
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-index">
        <span />
      </div>
      <svg>
        <defs />
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation={11} result="blur" />
          <feColorMatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"></feColorMatrix>
        </filter>
      </svg>
    </div>
  );
};

export default Loader;
